export { default, getWeatherIcon } from './WeatherIcon';
